/* HC dealer locator: hover tooltip, click/keyboard state selection, select mirror, panel. */
(function (window) {
  "use strict";

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function pluralize(n) {
    if (!n) return "No storefronts yet";
    return n + (n === 1 ? " storefront" : " storefronts");
  }

  function rowHtml(d) {
    var html = '<li class="hc-dealer-row"><a class="hc-dealer-row__name" href="' + escapeHtml(d.url) + '" target="_blank" rel="noopener">' + escapeHtml(d.name) + "</a>";
    if (d.city) html += '<span class="hc-dealer-row__sep" aria-hidden="true">—</span><span class="hc-dealer-row__place">' + escapeHtml(d.city) + ", " + escapeHtml(d.state) + "</span>";
    if (d.phone) html += '<span class="hc-dealer-row__sep" aria-hidden="true">—</span><a class="hc-dealer-row__phone" href="tel:' + escapeHtml(String(d.phone).replace(/[^\d+]/g, "")) + '">' + escapeHtml(d.phone) + "</a>";
    return html + "</li>";
  }

  function panelHtml(stateName, dealers) {
    if (!dealers.length) {
      return '<h2 class="hc-dealer-panel__title">' + escapeHtml(stateName) + '</h2><p class="hc-dealer-panel__note">No storefronts in ' + escapeHtml(stateName) + ' yet. <a href="#online">Shop online</a> instead.</p>';
    }
    return '<h2 class="hc-dealer-panel__title">' + escapeHtml(stateName) + " (" + dealers.length + ')</h2><ul class="hc-dealer-rows">' + dealers.map(rowHtml).join("") + "</ul>";
  }

  var DEFAULT_PANEL = '<h2 class="hc-dealer-panel__title">Pick a state</h2><p class="hc-dealer-panel__note">Choose a state on the map to see its storefronts, or <a href="#storefronts">browse the full list</a>.</p>';

  function init(doc) {
    var dataEl = doc.getElementById("hc-dealer-data");
    var select = doc.getElementById("hc-dealer-state-select");
    var panel = doc.getElementById("hc-dealer-panel");
    var figure = doc.querySelector(".hc-dealer-map__figure");
    var tooltip = doc.querySelector(".hc-dealer-map__tooltip");
    if (!dataEl || !select || !panel || !figure || !tooltip) return;

    var states = {};
    try { states = JSON.parse(dataEl.textContent).states || {}; } catch (e) { return; }
    var paths = figure.querySelectorAll(".hc-map__state[data-state]");
    var selected = "";

    function info(code) {
      var s = states[code] || { name: code, dealers: [] };
      return { name: s.name, dealers: s.dealers || [] };
    }

    Array.prototype.forEach.call(paths, function (p) {
      var i = info(p.getAttribute("data-state"));
      p.setAttribute("aria-label", i.name + ", " + pluralize(i.dealers.length).toLowerCase());
    });

    function setSelected(code) {
      selected = code === selected ? "" : code;
      Array.prototype.forEach.call(paths, function (p) {
        p.classList.toggle("is-selected", p.getAttribute("data-state") === selected);
      });
      select.value = selected;
      if (!selected) { panel.innerHTML = DEFAULT_PANEL; return; }
      var i = info(selected);
      panel.innerHTML = panelHtml(i.name, i.dealers);
    }

    function showTooltip(p, evt) {
      var i = info(p.getAttribute("data-state"));
      if (!i.dealers.length) { tooltip.hidden = true; return; }
      tooltip.textContent = i.name + " — " + pluralize(i.dealers.length);
      tooltip.hidden = false;
      var rect = figure.getBoundingClientRect();
      tooltip.style.left = (evt.clientX - rect.left) + "px";
      tooltip.style.top = (evt.clientY - rect.top) + "px";
    }

    Array.prototype.forEach.call(paths, function (p) {
      p.addEventListener("mouseenter", function (evt) { p.classList.add("is-hover"); showTooltip(p, evt); });
      p.addEventListener("mousemove", function (evt) { showTooltip(p, evt); });
      p.addEventListener("mouseleave", function () { p.classList.remove("is-hover"); tooltip.hidden = true; });
      p.addEventListener("click", function () { setSelected(p.getAttribute("data-state")); });
      p.addEventListener("keydown", function (evt) {
        if (evt.key === "Enter" || evt.key === " ") { evt.preventDefault(); setSelected(p.getAttribute("data-state")); }
      });
    });

    select.addEventListener("change", function () {
      selected = "";
      if (select.value) setSelected(select.value); else setSelected("");
    });
  }

  window.HCDealerLocator = { escapeHtml: escapeHtml, pluralize: pluralize, rowHtml: rowHtml, panelHtml: panelHtml, init: init };

  if (typeof window.document !== "undefined") {
    if (window.document.readyState === "loading") {
      window.document.addEventListener("DOMContentLoaded", function () { init(window.document); });
    } else {
      init(window.document);
    }
  }
})(window);
